import { useCallback, useState } from 'react';
import type { TableSortState } from './Table';

export interface UseTableSortResult {
  sort: TableSortState | null;
  // Pass straight to `Table`'s `onSortChange`.
  handleSortChange: (key: string) => void;
}

// Controlled sort state for `Table`, holding the toggle behaviour every
// sortable table in the app shares: re-clicking the active column flips its
// direction, picking a different one starts it ascending.
//
// `initialSort` is what lets a list open already ordered rather than in
// whatever order the backend happened to return it. Omit it for tables that
// should stay unsorted until the user asks for an order.
export function useTableSort(initialSort: TableSortState | null = null): UseTableSortResult {
  const [sort, setSort] = useState<TableSortState | null>(initialSort);

  const handleSortChange = useCallback((key: string) => {
    setSort((prev) =>
      prev?.key === key
        ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { key, direction: 'asc' }
    );
  }, []);

  return { sort, handleSortChange };
}
